import React, { useState } from 'react';

import RegistrationForm from '../shared/RegistrationForm';

import './FormSection.scss';

const FormSection = () => {
  const [formStatus, setFormStatus] = useState(null);

  return (
    <section id="contact-us" className="form-section">
      <div className="form-section__content max-w-[75.5rem] lg:flex-col lg:gap-6">
        {formStatus !== 'success' && (
          <div className="w-[40%] lg:w-full">
            <h2 className="font-Proxima text-[3rem] font-black uppercase leading-[1.16] text-white lg:text-[36px] sm:text-[2rem]">
              Request a demo
            </h2>
            <div className="mt-7 text-[1.5rem] leading-tight text-white lg:mt-5 lg:text-[18px]">
              SoftServe XR Design Pro is designed for consumer-level and industrial uses. Reach out to learn how we can
              help you leverage XR-driven customization!
            </div>
          </div>
        )}

        <div className="form-section__form-container">
          <RegistrationForm updateFormStatus={setFormStatus} />
        </div>
      </div>
    </section>
  );
};

export default FormSection;
